import React, { useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { BotContext } from "../../../../context";
const useStyles = createUseStyles((theme) => ({
  loading: {
    height: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  date: {
    textAlign: "center",
    margin: [12, 0],
    color: theme.dateColor,
    fontSize: theme.messageFontSize,
  },
  artak: {
    color: theme.automessageColor1,
    fontWeight: "bolder!important",
  },
  help: {
    color: theme.automessageColor2,
    fontWeight: "bolder",
  },
  moreButton: {
    background: `${theme.moreBtnBg}!important`,
    border: `${theme.moreBtnBg}!important`,
    direction: "rtl",
    fontSize: 10,
    height: 25,
    display: "flex!important",
    justifyContent: "center",
    alignItems: "center",
    margin: [15, "auto"],
  },
}));
const StartText = () => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const { selectedRoom, config } = useContext(BotContext);
  const { isSaderatCustomization } = config;
  let helperName;
  switch (selectedRoom?.name) {
    case "DEY":
      helperName = "تسهیلات بانک دی";
      break;
    case "Techno_IR_GPU":
      helperName = "مدیریت پروژه";
      break;
    default:
      helperName = selectedRoom?.descr;
      break;
  }
  return (
    <div>
      <div>سلام</div>
      <div>
        من{" "}
        <span className={styles.artak}>
          چت‌بات {isSaderatCustomization ? "صبا" : "آرتین"}
        </span>{" "}
        هستم.
        <div>اگر سوالی در مورد {helperName} داری از من بپرس.</div>
        <div>
          همیشه میتونی <span className={styles.help}>"کمک"</span> رو به عنوان
          سوال تایپ کنی تا بدونی چطوری بپرسی.{" "}
        </div>
      </div>
    </div>
  );
};

export { StartText };
